import React from "react";
import MediaQueryUtils from "../../utils/MediaQueryUtils";
import {useSelector} from "react-redux";

function InformationBar(props){
    let isPageWide = MediaQueryUtils('(min-width: 950px)')
    const getAssistente = useSelector(state => state.wizardReducer)
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}
    return (
        <div style={{backgroundColor:"#F8F8F8",height:"120px", display:sessioneUtente && (sessioneUtente.tipoUtente === "02" ||sessioneUtente.tipoUtente === "03" )?"none":""}}>
            <div className={"row"} style={{height:"100%"}}>
                <div className={isPageWide?"col-3":"col-4"}
                     style={{marginLeft: "2rem", display: "flex", alignItems: "center", flexWrap: "wrap"}}>
                    <div style={{borderLeft: "2px solid #1b7ea9", height: "70px",}}>
                        <span style={{marginLeft:"5px",fontWeight:"bold",fontSize:"18px",color:"#1b7ea9"}}>Assistente Familiare</span>
                        <br/>
                        <span style={{marginLeft:"5px"}}>{getAssistente && getAssistente.datiAnagrafici && getAssistente.datiAnagrafici.nome && getAssistente.datiAnagrafici.cognome ?getAssistente.datiAnagrafici.nome.toUpperCase() +" "+getAssistente.datiAnagrafici.cognome.toUpperCase() :""}</span>
                    </div>
                </div>
                <div className={isPageWide?"col-3":"col-4"} style={{marginLeft: "2rem", display: "flex", alignItems: "center", flexWrap: "wrap"}}>
                    <div style={{borderLeft: "2px solid #1b7ea9", height: "70px"}}>
                        <span style={{marginLeft:"5px",fontWeight:"bold",fontSize:"18px",color:"#1b7ea9"}}>Referente Sportello</span>
                        <br/>
                        <span style={{marginLeft:"5px"}}>{sessioneUtente && sessioneUtente.nome && sessioneUtente.cognome?
                            sessioneUtente.nome.toUpperCase() + " "+sessioneUtente.cognome.toUpperCase():""}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default InformationBar